import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import AuthShell from 'components/layout/Auth/AuthShell';
import ResetPassword from 'newComponents/ResetPassword';

import LoginForm from './LoginForm';

const Login = (): JSX.Element => {
  const [showModalResetPass, setShowModalRestPass] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    sessionStorage.removeItem('@UltragazEmpresarial:X-Mfa-Login');

    if (localStorage.getItem('@UltragazEmpresarial:accessToken')) {
      history.push('/portal');
    }
  }, [history]);

  return (
    <>
      <AuthShell>
        <LoginForm setShowModalRestPass={setShowModalRestPass} />
      </AuthShell>
      <ResetPassword
        setShowModal={setShowModalRestPass}
        showModal={showModalResetPass}
      />
    </>
  );
};

export default Login;
